<template>
    <ais-hierarchical-menu
        :show-parent-level="false"
        :attributes="attributes"
        :transform-items="transformItems"
        :class="classes"
        :limit="100"
        v-slot="{ items, refine, createURL }"
    >
        <ul v-if="withImages" class="ais-HierarchicalMenu-list">
            <li
                v-for="item in items?.[0]?.data" :key="item.value"
                class="ais-HierarchicalMenu-item"
            >
                <a
                    :href="createURL(item.value)"
                    class="ais-HierarchicalMenu-link"
                >
                    {{ item.label }}

                    <img :src="categoryImages[item.label]" alt="">
                </a>
            </li>
        </ul>
    </ais-hierarchical-menu>
</template>
<script>
import axios from 'axios'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default {
    data: () => ({
        categoryImages: {},
        attributes: [
            'categoryLvl0',
            'categoryLvl1',
            'categoryLvl2',
            'categoryLvl3',
            'categoryLvl4'
        ],
    }),
    props: {
        layout: { type: String, default: '' },
        withImages: { type: Boolean, default: false },
    },
    computed: {
        classes() {
            if (this.withImages) {
                return '-withImages'
            }

            return ''
        },
    },
    methods: {
        filterTree(items, parent) {
            if (!items) {
                if (parent) {
                    return [ parent ]
                }
                return []
            }
            const refined = items.find(({ isRefined }) => isRefined)
            if (refined) {
                return this.filterTree(refined.data, refined)
            }

            if (parent) {
                return [ parent ]
            }
            return items
        },

        fetchImages(categories = []) {
            if (!categories) { return }
            const toFetch = categories.filter(category => !(category in this.categoryImages))
                .map(category => category.label)
            if (toFetch.length == 0) { return }

            axios.get('/actions/category-api-module/children/fetch-images', { params: { categories: toFetch } })
                .then(r => {
                    r.data.forEach(({ name, img }) => {
                        this.$set(this.categoryImages, name, img)
                    })
                })
        },

        transformItems(items) {
            items = this.filterTree(items)

            if (this.withImages) {
                this.fetchImages(items?.[0]?.data)
            }

            return items
        }
    }
}
</script>
